import logo from './logo.png';
import blacklogo from './blacklogo.png';
import linkedin from './linkedin.svg';
import homeabout from './home_about-1.png';
import marketfocus from './market_focus-min.png';
import client1 from './client1.png';
import client2 from './client2.png';
import client4 from './client4.png';
import client3 from './client3.png';
import client5 from './client5.png';
import team1 from './about_img1.jpg';
import team2 from './profile_img3.jpg';
import team3 from './profile_img4.jpg';
import partnet1 from './t1.png';
import partnet2 from './t2.png';
import partnet3 from './t3.png';
import timeline from './timeline_1.svg';
import investorpagebg from './investors_page_banner.jpg';
import formbg from './form_bg.jpg';
import contactbg from './contact_page_banner-1.jpg';
import portfoliobg from './portfolio_page_banner.jpg';
import investor1 from './investor1.jpg';
import investor2 from './investor2.jpg';
import teamellipse1 from './Ellipse-52-1.png';
import teamellipse2 from './Ellipse-53-1.png';
import videocover from './videocover.png';
import aboutbanner from './about_banner.jpg';
import mediabg from './video_page_banner.jpg';
import market_focus from './marketfocus.jpg';
import roadmap from './Brandon.jpeg';
import redwood1 from './Unit.jpg';
import redwood2 from './Exterior-Night.jpeg';
import redwood3 from './The-Falls.jpg';
import soldstamp from './sold-stamp.png';
import podcast from './podcast.png';
import thumbnail1 from './thumbnail1.png';
import thumbnail2 from './thumbnail2.png';
import thumbnail3 from './thumbnail3.png';
import thumbnail4 from './thumbnail4.png';
import thumbnail5 from './thumbnail5.png';
import host1 from './host1.jpg';
import host2 from './host2.jpg';
import host3 from './host3.jpg';
import host4 from './host6.png';
import host5 from './host7.png';
import playbutton from './play.png';
import timeline1 from './timeline_1.svg';
import timeline2 from './timeline_2.svg';
import recentproject from './recentproject.png';
import videoCover2 from './video-cover.png';
import currentimgbg from './currentproject/currentprojectbg.png';
import currentprojectimg1 from './currentproject/projectimg1.png';
import currentprojectimg2 from './currentproject/projectimg2.png';
import currentprojectimg3 from './currentproject/projectimg3.png';
import aspencover from './currentproject/aspencover.png';
import spotlightbg from './currentproject/spotlightbg.png';
import broadwalkteam1 from './currentproject/boardwalk-team-1.png';
import broadwalkteam2 from './currentproject/boardwalk-team-2.png';
import broadwalkteam3 from './currentproject/boardwalk-team-3.png';
import checksvg from './check.svg';

export const image={
    logo,
    blacklogo,
    linkedin,
    homeabout,
    marketfocus,
    client1,
    client2,
    client3,
    client4,
    client5,
    team1,
    team2,
    team3,
    partnet1,
    partnet2,
    partnet3,
    timeline,   
    investorpagebg,
    formbg,
    investor1,
    investor2,
    contactbg,
    teamellipse1,
    teamellipse2,
    portfoliobg,
    videocover,
    aboutbanner,
    mediabg,
    market_focus,
    roadmap,
    redwood1,
    redwood2,
    redwood3,
    soldstamp,
    podcast,
    thumbnail1,
    thumbnail2,
    thumbnail3,
    thumbnail4,
    thumbnail5,
    host1,
    host2,
    host3,
    host4,
    host5,
    playbutton,
    timeline1,
    timeline2,
    recentproject,
    videoCover2,
    currentimgbg,
    currentprojectimg1,
    currentprojectimg2,
    currentprojectimg3,
    aspencover,
    spotlightbg,
    broadwalkteam1,
    broadwalkteam2,
    broadwalkteam3,
    checksvg,
}